(self["webpackChunkbibendum"] = self["webpackChunkbibendum"] || []).push([[0],{

/***/ 330:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Modal": () => (/* reexport safe */ _modal__WEBPACK_IMPORTED_MODULE_0__.default),
/* harmony export */   "Search": () => (/* reexport safe */ _search__WEBPACK_IMPORTED_MODULE_1__.default),
/* harmony export */   "SideCart": () => (/* reexport safe */ _side_cart__WEBPACK_IMPORTED_MODULE_2__.default)
/* harmony export */ });
/* harmony import */ var _modal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(331);
/* harmony import */ var _search__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(348);
/* harmony import */ var _side_cart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(358);




/***/ }),

/***/ 332:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(148);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(142);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(146);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(147);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(123);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(124);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(137);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(138);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(139);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(326);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(333);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var focus_trap_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(342);
/* harmony import */ var focus_trap_react__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(focus_trap_react__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(346);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _assets_svg_icon_cross_svg__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(347);












function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }








var Modal = function Modal(_ref) {
  var _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      triggerLabel = _ref.triggerLabel,
      _ref$closeLabel = _ref.closeLabel,
      closeLabel = _ref$closeLabel === void 0 ? 'Close Modal' : _ref$closeLabel,
      className = _ref.className,
      children = _ref.children,
      _ref$container = _ref.container,
      container = _ref$container === void 0 ? document.body : _ref$container,
      toggleClass = _ref.toggleClass,
      toggleEvent = _ref.toggleEvent;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(isOpen),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var toggleScrollLock = function toggleScrollLock() {
    var _document$querySelect;

    return (_document$querySelect = document.querySelector('html')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.classList.toggle('scroll-lock');
  };

  var toggleOpenClass = function toggleOpenClass() {
    var _document$querySelect2;

    var toggleClassString = toggleClass ? "".concat(toggleClass, "-") : '';
    (_document$querySelect2 = document.querySelector('html')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.classList.toggle("modal-".concat(toggleClassString, "open"));
  };

  var closeModal = function closeModal() {
    setOpen(false);
    toggleScrollLock();
    toggleOpenClass();
  };

  var toggleModal = function toggleModal() {
    setOpen(!open);
    toggleScrollLock();
    toggleOpenClass();
  };

  var handleEscKey = function handleEscKey(event) {
    return event.keyCode === 27 && closeModal();
  };

  var handleOutsideClick = function handleOutsideClick(event) {
    return event.target === event.currentTarget && closeModal();
  };
  /**
   * The below useEffect() allows the modal to be toggled with a custom event; toggleEvent.
   */


  (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function () {
    if (!toggleEvent) return;
    document.addEventListener(toggleEvent, toggleModal);
    return function () {
      return document.removeEventListener(toggleEvent, toggleModal);
    };
  }, [open]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11__.default.createElement(react__WEBPACK_IMPORTED_MODULE_11__.default.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11__.default.createElement("button", {
    onClick: toggleModal,
    className: classnames__WEBPACK_IMPORTED_MODULE_14___default()('modal__trigger', className),
    type: "button"
  }, triggerLabel), !open && null, open && /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_11__.createPortal)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11__.default.createElement((focus_trap_react__WEBPACK_IMPORTED_MODULE_13___default()), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11__.default.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_14___default()('modal', size === 'sm' && 'modal--sm', size === 'md' && 'modal--md'),
    role: "dialog",
    tabIndex: -1,
    "aria-modal": "true",
    onClick: handleOutsideClick,
    onKeyDown: handleEscKey
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11__.default.createElement("div", {
    className: "modal__dialog"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11__.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11__.default.createElement("button", {
    className: "modal__close-button",
    onClick: closeModal,
    "aria-label": closeLabel,
    type: "button"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11__.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: _assets_svg_icon_cross_svg__WEBPACK_IMPORTED_MODULE_15__
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11__.default.createElement("div", {
    className: "modal__body"
  }, children))))), container));
};

Modal.propTypes = {
  isOpen: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().bool),
  size: prop_types__WEBPACK_IMPORTED_MODULE_12___default().oneOf(['sm', 'md', 'full-screen']),
  triggerLabel: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().node),
  closeLabel: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string),
  children: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().node),
  container: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().node),
  toggleEvent: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string),
  toggleClass: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Modal);

/***/ }),

/***/ 331:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* reexport safe */ _Modal__WEBPACK_IMPORTED_MODULE_0__.default)
/* harmony export */ });
/* harmony import */ var _Modal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(332);


/***/ }),

/***/ 349:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(195);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(171);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(123);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(124);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(138);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(102);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(210);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(229);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(230);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(231);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(137);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(214);
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(132);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(135);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(252);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(139);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(205);
/* harmony import */ var core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(110);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(148);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(142);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(146);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(147);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(350);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(351);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(352);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(353);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(326);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(333);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(346);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _assets_scripts_utils_debounce__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(196);
/* harmony import */ var _search_results__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(354);
/* harmony import */ var _assets_scripts_utils_api__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(272);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(273);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }


































function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }









var Search = function Search(_ref) {
  var _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      placeholder = _ref.placeholder,
      rootUrl = _ref.rootUrl,
      resources = _ref.resources,
      unavailableProducts = _ref.unavailableProducts,
      showSearchSuggestions = _ref.showSearchSuggestions,
      searchSuggestionsTitle = _ref.searchSuggestionsTitle,
      searchSuggestions = _ref.searchSuggestions,
      resultMoneyFormat = _ref.resultMoneyFormat,
      searchIcon = _ref.searchIcon,
      clearIcon = _ref.clearIcon,
      typeProductsTitle = _ref.typeProductsTitle,
      typeCollectionsTitle = _ref.typeCollectionsTitle,
      typeArticlesTitle = _ref.typeArticlesTitle,
      typePagesTitle = _ref.typePagesTitle,
      viewAllString = _ref.viewAllString,
      toggleEvent = _ref.toggleEvent,
      triggerLabel = _ref.triggerLabel,
      className = _ref.className;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_33__.useState)(isOpen),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_33__.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      searchTerm = _useState4[0],
      setSearchTerm = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_33__.useState)({
    products: [],
    collections: [],
    pages: [],
    articles: []
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      results = _useState6[0],
      setResults = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_33__.useState)(),
      _useState8 = _slicedToArray(_useState7, 2),
      suggestionsFromResults = _useState8[0],
      setSuggestionsFromResults = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_33__.useState)(),
      _useState10 = _slicedToArray(_useState9, 2),
      searchStyles = _useState10[0],
      setSearchStyles = _useState10[1];

  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_33__.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      showResults = _useState12[0],
      setShowResults = _useState12[1];

  var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_33__.useRef)();
  var wrapper = (0,react__WEBPACK_IMPORTED_MODULE_33__.useRef)(null);

  var buildResourceString = function buildResourceString(obj) {
    return Object.keys(obj).map(function (param) {
      return "resources[".concat(param, "]=").concat(obj[param]);
    }).join('&');
  };

  var abortController = (0,react__WEBPACK_IMPORTED_MODULE_33__.useRef)();
  var resourceString = buildResourceString(resources);
  var mobileQuery = window.matchMedia("(max-width: ".concat(window.theme.breakpoints.large, "px)"));
  var stylesObject = {};

  var uniqueArray = function uniqueArray(value, index, self) {
    return self.indexOf(value) === index;
  };

  var fetchImage = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(handle) {
      var _response$data$data$p;

      var data, response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              data = " \n    {\n        pages(first: 1, query: \"handle:'".concat(handle, "'\") {\n            edges {\n                node {\n                    title\n                    handle\n                    featuredImage: metafield(namespace: \"custom\", key: \"featured_image\" ) {\n                        reference {\n                            ... on MediaImage {\n                            image {\n                                originalSrc\n                            }\n                            }\n                        }\n                    }   \n                }\n            }\n        }\n    }\n  ");
              _context.next = 3;
              return axios__WEBPACK_IMPORTED_MODULE_39__.default.post("https://".concat(Shopify.shop, "/api/graphql"), data, _assets_scripts_utils_api__WEBPACK_IMPORTED_MODULE_38__.storefrontRequestConfig);

            case 3:
              response = _context.sent;
              return _context.abrupt("return", (_response$data$data$p = response.data.data.pages.edges[0].node.featuredImage) === null || _response$data$data$p === void 0 ? void 0 : _response$data$data$p.reference.image.originalSrc);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchImage(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var fetchResults = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(term) {
      var url, response, json, pageData;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              url = "".concat(rootUrl, "/search/suggest.json?q=").concat(term, "&").concat(resourceString, "&resources[options][unavailable_products]=").concat(unavailableProducts);
              _context3.prev = 1;
              _context3.next = 4;
              return fetch(url, {
                signal: abortController.current.signal
              });

            case 4:
              response = _context3.sent;

              if (!(response.ok === false)) {
                _context3.next = 7;
                break;
              }

              throw new Error('Search response was not OK');

            case 7:
              _context3.next = 9;
              return response.json();

            case 9:
              json = _context3.sent;
              _context3.next = 12;
              return Promise.all(json.resources.results.pages.map( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(page) {
                  var pageImage;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          console.log(page);
                          _context2.next = 3;
                          return fetchImage(page.handle);

                        case 3:
                          pageImage = _context2.sent;
                          console.log(pageImage);
                          return _context2.abrupt("return", _objectSpread(_objectSpread({}, page), {}, {
                            pageImage: pageImage
                          }));

                        case 6:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x3) {
                  return _ref4.apply(this, arguments);
                };
              }()));

            case 12:
              pageData = _context3.sent;
              return _context3.abrupt("return", {
                results: _objectSpread(_objectSpread({}, json.resources.results), {}, {
                  pages: _toConsumableArray(pageData)
                })
              });

            case 16:
              _context3.prev = 16;
              _context3.t0 = _context3["catch"](1);

              if (!(_context3.t0.name === 'AbortError')) {
                _context3.next = 20;
                break;
              }

              return _context3.abrupt("return", null);

            case 20:
              window.console.error(_context3.t0);
              return _context3.abrupt("return", null);

            case 22:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 16]]);
    }));

    return function fetchResults(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var getSuggestionsFromResults = function getSuggestionsFromResults(productResults, term) {
    var _ref5;

    if (!productResults) return;
    var titles = productResults.map(function (product) {
      return product.title;
    });
    var titleStringArrays = titles.map(function (title) {
      return title.split(' ');
    });

    var flattenedTitleArray = (_ref5 = []).concat.apply(_ref5, _toConsumableArray(titleStringArrays));

    var onlyStringsContainingSearchTerm = flattenedTitleArray.filter(function (string) {
      return string.toLowerCase().includes(term.toLowerCase());
    });
    var uniqueStrings = onlyStringsContainingSearchTerm.filter(uniqueArray);
    var suggestions = uniqueStrings.filter(function (string) {
      return string.toLowerCase() !== term.toLowerCase();
    });
    var firstSixSuggestions = suggestions.slice(0, 6);
    setSuggestionsFromResults(firstSixSuggestions);
  };

  var updateResults = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(term) {
      var searchResponse, products, collections, pages, articles, productData;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return fetchResults(term);

            case 3:
              searchResponse = _context5.sent;

              if (!(searchResponse !== null)) {
                _context5.next = 18;
                break;
              }

              products = searchResponse.results.products || [];
              collections = searchResponse.results.collections || [];
              pages = searchResponse.results.pages || [];
              articles = searchResponse.results.articles || [];
              /**
               * For logged in customers who have any HVWC: discount tags
               * we need to fetch SKU data for the returned results in order to
               * calculate the prices correctly.
               */

              if (!(window.theme.customer.isLoggedIn && window.theme.customer.tags.some(function (tag) {
                return tag.includes('HVWC:');
              }))) {
                _context5.next = 14;
                break;
              }

              _context5.next = 12;
              return Promise.all(searchResponse.results.products.map( /*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(product) {
                  var handle, response, data;
                  return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          handle = product.handle;
                          _context4.next = 3;
                          return fetch("/products/".concat(handle, ".json"));

                        case 3:
                          response = _context4.sent;
                          _context4.next = 6;
                          return response.json();

                        case 6:
                          data = _context4.sent;
                          return _context4.abrupt("return", data.product);

                        case 8:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                }));

                return function (_x5) {
                  return _ref7.apply(this, arguments);
                };
              }()));

            case 12:
              productData = _context5.sent;
              products.forEach(function (product) {
                var matchingProductData = productData.find(function (_ref8) {
                  var handle = _ref8.handle;
                  return handle === product.handle;
                });
                if (!matchingProductData) return;
                product.sku = matchingProductData.variants.map(function (_ref9) {
                  var sku = _ref9.sku;
                  return sku;
                });
              });

            case 14:
              console.log(searchResponse);
              setResults({
                products: products,
                collections: collections,
                pages: pages,
                articles: articles
              });
              getSuggestionsFromResults(searchResponse.results.products, term);
              setShowResults(true);

            case 18:
              _context5.next = 23;
              break;

            case 20:
              _context5.prev = 20;
              _context5.t0 = _context5["catch"](0);
              window.console.error(_context5.t0);

            case 23:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 20]]);
    }));

    return function updateResults(_x4) {
      return _ref6.apply(this, arguments);
    };
  }();

  var debouncedUpdateResults = (0,react__WEBPACK_IMPORTED_MODULE_33__.useCallback)((0,_assets_scripts_utils_debounce__WEBPACK_IMPORTED_MODULE_36__.debounce)(function (term) {
    return updateResults(term);
  }, 300), []);
  (0,react__WEBPACK_IMPORTED_MODULE_33__.useEffect)(function () {
    if (abortController.current) {
      abortController.current.abort();
    }

    abortController.current = new AbortController();
    var searchPageResults = document.querySelector('[data-search-page-results]');

    if (!searchTerm) {
      setShowResults(false);

      if (wrapper.current) {
        wrapper.current.classList.remove('search-modal__wrapper--absolute');
      }

      if (searchPageResults) {
        searchPageResults.classList.remove('hide');
      }

      return;
    }

    wrapper.current.classList.add('search-modal__wrapper--absolute');

    if (searchPageResults) {
      searchPageResults.classList.add('hide');
    }

    debouncedUpdateResults(searchTerm);
  }, [searchTerm]);

  var updateSearchTerm = function updateSearchTerm(value) {
    return setSearchTerm(value);
  };

  var handleChange = function handleChange(evt) {
    evt.persist();
    updateSearchTerm(evt.target.value);
  };

  var clearInput = function clearInput() {
    updateSearchTerm('');
    setSearchTerm('');
  };

  var populateSearch = function populateSearch(suggestion) {
    setSearchTerm(suggestion);
  };

  var toggleScrollLock = function toggleScrollLock() {
    var _document$querySelect;

    return (_document$querySelect = document.querySelector('html')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.classList.toggle('scroll-lock');
  };

  var closeModal = function closeModal() {
    setOpen(false);
    toggleScrollLock();
  };

  var toggleModal = function toggleModal() {
    setOpen(!open);
    toggleScrollLock();
    var activeHeaderItems = Array.from(document.querySelectorAll('.nav__item.nav__item--has-child.is-expanded'));
    activeHeaderItems.forEach(function (item) {
      if (!item.classList.contains('is-expanded')) return;
      item.classList.remove('is-expanded');
      item.classList.add('is-collapsed');
    });
    document.body.classList.remove('dropdown-is-active');
  };

  var handleEscKey = function handleEscKey(event) {
    return event.keyCode === 27 && closeModal();
  };

  var handleOutsideClick = function handleOutsideClick(event) {
    return event.target === event.currentTarget && closeModal();
  };

  var setSearchHeight = function setSearchHeight() {
    var _announcementBar$getB, _announcementBar$getB2;

    if (mobileQuery.matches) return;
    var announcementBar = document.querySelector('.announcements');
    var announcementBarBottom = (_announcementBar$getB = announcementBar === null || announcementBar === void 0 ? void 0 : (_announcementBar$getB2 = announcementBar.getBoundingClientRect()) === null || _announcementBar$getB2 === void 0 ? void 0 : _announcementBar$getB2.bottom) !== null && _announcementBar$getB !== void 0 ? _announcementBar$getB : 0;
    var windowHeightMinusannouncementBar = window.innerHeight - announcementBarBottom;

    if (announcementBarBottom > 0) {
      stylesObject.height = "".concat(windowHeightMinusannouncementBar, "px");
      setSearchStyles(stylesObject);
    }
  };

  var openMobileSearch = function openMobileSearch() {
    if (!mobileQuery.matches || open) return;
    var targetNode = document.body;
    var config = {
      attributes: true
    };

    var callback = function callback(mutationList) {
      if (mutationList[0].attributeName !== 'class' && !mutationList[0].target.classList.contains('menu-is-expanded')) return;
      setOpen(true);
    };

    var observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_33__.useEffect)(function () {
    openMobileSearch();
  });
  (0,react__WEBPACK_IMPORTED_MODULE_33__.useEffect)(function () {
    if (inputRef.current && !mobileQuery.matches) {
      inputRef.current.focus();
    }

    setSearchHeight();
    if (!toggleEvent) return;
    document.addEventListener(toggleEvent, toggleModal);
    return function () {
      return document.removeEventListener(toggleEvent, toggleModal);
    };
  }, [open]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_33__.default.createElement(react__WEBPACK_IMPORTED_MODULE_33__.default.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_33__.default.createElement("button", {
    onClick: toggleModal,
    className: classnames__WEBPACK_IMPORTED_MODULE_35___default()('search-modal__trigger', className),
    type: "button",
    style: "display: flex; width: 100%; text-align: left;"
  }, searchIcon), !open && null, open && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_33__.default.createElement(react__WEBPACK_IMPORTED_MODULE_33__.default.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_33__.default.createElement("div", {
    className: "search-modal__mask",
    onclick: handleOutsideClick,
    onKeyDown: handleEscKey
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_33__.default.createElement("div", {
    className: "search-modal__wrapper",
    style: searchStyles,
    ref: wrapper
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_33__.default.createElement("div", {
    className: "search-modal__form-wrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_33__.default.createElement("form", {
    className: "search__form",
    action: "".concat(rootUrl, "/search"),
    method: "GET",
    role: "search"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_33__.default.createElement("input", {
    type: "hidden",
    name: "type",
    value: "product"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_33__.default.createElement("input", {
    type: "hidden",
    name: "filter.v.availability",
    value: "1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_33__.default.createElement("input", {
    className: "search__input",
    name: "q",
    value: searchTerm,
    placeholder: placeholder,
    onChange: handleChange,
    "aria-label": placeholder,
    ref: inputRef,
    enterKeyHint: "search",
    autoComplete: "off"
  }), searchIcon, searchTerm && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_33__.default.createElement("button", {
    type: "button",
    "class": "search__clear",
    onClick: clearInput
  }, clearIcon))), searchTerm && suggestionsFromResults && suggestionsFromResults.length > 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_33__.default.createElement("div", {
    className: "quick-search__suggestions-from-results"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_33__.default.createElement("h6", {
    className: "h-small"
  }, window.theme.strings.search.suggestions), suggestionsFromResults.map(function (suggestion) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_33__.default.createElement("div", {
      className: "quick-search__result-suggestion",
      key: suggestion
    }, suggestion);
  })), !searchTerm && showSearchSuggestions && searchSuggestions && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_33__.default.createElement(react__WEBPACK_IMPORTED_MODULE_33__.default.Fragment, null, searchSuggestionsTitle && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_33__.default.createElement("h4", null, searchSuggestionsTitle), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_33__.default.createElement("div", {
    "class": "search__suggestions"
  }, searchSuggestions.map(function (suggestion) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_33__.default.createElement("button", {
      type: "button",
      className: "btn",
      key: suggestion,
      onClick: function onClick() {
        return populateSearch(suggestion);
      }
    }, suggestion);
  }))), showResults && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_33__.default.createElement(react__WEBPACK_IMPORTED_MODULE_33__.default.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_33__.default.createElement(_search_results__WEBPACK_IMPORTED_MODULE_37__.default, {
    searchTerm: searchTerm,
    results: results,
    rootUrl: rootUrl,
    moneyFormat: resultMoneyFormat,
    typeProductsTitle: typeProductsTitle,
    typeCollectionsTitle: typeCollectionsTitle,
    typeArticlesTitle: typeArticlesTitle,
    typePagesTitle: typePagesTitle,
    viewAllString: viewAllString
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_33__.default.createElement("p", {
    "class": "quick-search-results__view-more"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_33__.default.createElement("a", {
    href: "".concat(rootUrl, "/search?type=product&filter.v.availability=1&q=").concat(searchTerm, "*"),
    "class": ""
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_33__.default.createElement("h6", {
    className: "h-small"
  }, viewAllString.replace('{{amount}}', results.products.length))))))));
}; // Shopify's Predictive Search API reference:
// https://shopify.dev/docs/themes/ajax-api/reference/predictive-search


Search.propTypes = {
  isOpen: (prop_types__WEBPACK_IMPORTED_MODULE_34___default().bool),
  placeholder: (prop_types__WEBPACK_IMPORTED_MODULE_34___default().string.isRequired),
  rootUrl: (prop_types__WEBPACK_IMPORTED_MODULE_34___default().string.isRequired),
  resources: prop_types__WEBPACK_IMPORTED_MODULE_34___default().shape({
    type: (prop_types__WEBPACK_IMPORTED_MODULE_34___default().string),
    limit: (prop_types__WEBPACK_IMPORTED_MODULE_34___default().number)
  }).isRequired,
  unavailableProducts: (prop_types__WEBPACK_IMPORTED_MODULE_34___default().string.isRequired),
  showSearchSuggestions: (prop_types__WEBPACK_IMPORTED_MODULE_34___default().bool),
  searchSuggestionsTitle: (prop_types__WEBPACK_IMPORTED_MODULE_34___default().string),
  searchSuggestions: prop_types__WEBPACK_IMPORTED_MODULE_34___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_34___default().string)),
  resultMoneyFormat: (prop_types__WEBPACK_IMPORTED_MODULE_34___default().string.isRequired),
  searchIcon: (prop_types__WEBPACK_IMPORTED_MODULE_34___default().string),
  clearIcon: (prop_types__WEBPACK_IMPORTED_MODULE_34___default().string),
  typeProductsTitle: (prop_types__WEBPACK_IMPORTED_MODULE_34___default().string),
  typeCollectionsTitle: (prop_types__WEBPACK_IMPORTED_MODULE_34___default().string),
  typeArticlesTitle: (prop_types__WEBPACK_IMPORTED_MODULE_34___default().string),
  typePagesTitle: (prop_types__WEBPACK_IMPORTED_MODULE_34___default().string),
  viewAllString: (prop_types__WEBPACK_IMPORTED_MODULE_34___default().string),
  toggleEvent: (prop_types__WEBPACK_IMPORTED_MODULE_34___default().string),
  triggerLabel: (prop_types__WEBPACK_IMPORTED_MODULE_34___default().node),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_34___default().string)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Search);

/***/ }),

/***/ 348:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* reexport safe */ _Search__WEBPACK_IMPORTED_MODULE_0__.default)
/* harmony export */ });
/* harmony import */ var _Search__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(349);


/***/ }),

/***/ 356:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(229);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(230);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(231);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(214);
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(326);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(333);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(243);
/* harmony import */ var _assets_scripts_utils_pricing__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(251);
/* harmony import */ var _assets_scripts_utils_shopify_images__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(357);










var showPrice = function showPrice(tags) {
  if (window.theme.customer.isRequired && !window.theme.customer.isLoggedIn) {
    return false;
  }

  if (tags) {
    var stateExclusionTags = tags.filter(function (tag) {
      return tag.includes('EXCLUDE_STATE:');
    });
    var customersStateIsExcluded = window.theme.customer.province && stateExclusionTags.some(function (tag) {
      return tag.includes(window.theme.customer.province);
    });

    if (customersStateIsExcluded) {
      return false;
    }

    return true;
  }
};

var SearchResult = function SearchResult(_ref) {
  var _result$featured_imag;

  var result = _ref.result,
      moneyFormat = _ref.moneyFormat;
  var price = (0,_assets_scripts_utils_pricing__WEBPACK_IMPORTED_MODULE_7__.discountedProductPrice)(window.theme.customer.tags, result.price * 100, result.tags, result.sku);
  console.log(result);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.default.createElement("div", {
    key: result.id,
    className: "quick-search-results__cell"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.default.createElement("a", {
    href: result.url,
    className: "quick-search-results__image"
  }, (result === null || result === void 0 ? void 0 : (_result$featured_imag = result.featured_image) === null || _result$featured_imag === void 0 ? void 0 : _result$featured_imag.url) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.default.createElement("img", {
    src: (0,_assets_scripts_utils_shopify_images__WEBPACK_IMPORTED_MODULE_8__.imageUrl)(result.featured_image.url, 300),
    width: result.featured_image.width,
    height: result.featured_image.height,
    alt: result.featured_image.alt
  }), result.pageImage && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.default.createElement("img", {
    src: (0,_assets_scripts_utils_shopify_images__WEBPACK_IMPORTED_MODULE_8__.imageUrl)(result.pageImage, 300)
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.default.createElement("span", {
    className: "quick-search-results__title"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.default.createElement("a", {
    href: result.url
  }, result.title)), showPrice(result.tags) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.default.createElement("p", {
    className: "quick-search-results__price"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.default.createElement("span", {
    className: "money"
  }, (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_6__.formatMoney)(price, moneyFormat))));
};

SearchResult.propTypes = {
  result: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().object),
  moneyFormat: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SearchResult);

/***/ }),

/***/ 355:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(195);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(350);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(142);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(229);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(351);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(132);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(135);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(352);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(353);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(326);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(333);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _search_result_SearchResult__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(356);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }















var SearchResults = function SearchResults(_ref) {
  var searchTerm = _ref.searchTerm,
      results = _ref.results,
      moneyFormat = _ref.moneyFormat,
      typeProductsTitle = _ref.typeProductsTitle,
      typeCollectionsTitle = _ref.typeCollectionsTitle,
      typeArticlesTitle = _ref.typeArticlesTitle,
      typePagesTitle = _ref.typePagesTitle;
  var products = results.products,
      collections = results.collections,
      pages = results.pages,
      articles = results.articles;
  var totalResults = products.length + collections.length + pages.length + articles.length;

  var renderResultGrid = function renderResultGrid(src, title) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.default.createElement("div", {
      className: "quick-search-results__section quick-search-results__section--".concat(title)
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.default.createElement("h6", {
      className: "quick-search-results__section-title h-small"
    }, title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.default.createElement("div", {
      className: "quick-search-results__grid quick-search-results__grid--".concat(title)
    }, src.map(function (result) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.default.createElement(_search_result_SearchResult__WEBPACK_IMPORTED_MODULE_12__.default, {
        key: result.id,
        result: result,
        moneyFormat: moneyFormat
      });
    })));
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.default.createElement("div", {
    className: "quick-search-results"
  }, totalResults < 1 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.default.createElement("p", null, "Sorry, no top results for \"", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.default.createElement("em", {
    className: "quick-search-results__search-term"
  }, searchTerm), "\"."), products.length >= 1 && renderResultGrid(products, typeProductsTitle), articles.length >= 1 && renderResultGrid(articles, typeArticlesTitle), collections.length >= 1 && renderResultGrid(collections, typeCollectionsTitle), pages.length >= 1 && renderResultGrid(pages, typePagesTitle));
};

var TypeCoreResult = {
  id: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().number),
  url: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().string),
  title: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().string)
};
var TypeImageResult = {
  featured_image: prop_types__WEBPACK_IMPORTED_MODULE_11___default().shape({
    url: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().string),
    aspect_ratio: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().number),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().string),
    width: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().number),
    height: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().number)
  })
};
var TypeFormResult = {
  variants: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().array)
};
SearchResults.propTypes = {
  searchTerm: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().string),
  results: prop_types__WEBPACK_IMPORTED_MODULE_11___default().shape({
    products: prop_types__WEBPACK_IMPORTED_MODULE_11___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_11___default().shape(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, TypeCoreResult), TypeImageResult), TypeFormResult), {}, {
      price: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().string)
    }))),
    collections: prop_types__WEBPACK_IMPORTED_MODULE_11___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_11___default().shape(_objectSpread(_objectSpread({}, TypeCoreResult), TypeImageResult))),
    pages: prop_types__WEBPACK_IMPORTED_MODULE_11___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_11___default().shape(_objectSpread({}, TypeCoreResult))),
    articles: prop_types__WEBPACK_IMPORTED_MODULE_11___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_11___default().shape(_objectSpread(_objectSpread({}, TypeCoreResult), TypeImageResult)))
  }).isRequired,
  moneyFormat: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().string.isRequired),
  typeProductsTitle: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().string),
  typeCollectionsTitle: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().string),
  typeArticlesTitle: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().string),
  typePagesTitle: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().string)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SearchResults);

/***/ }),

/***/ 354:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* reexport safe */ _SearchResults__WEBPACK_IMPORTED_MODULE_0__.default)
/* harmony export */ });
/* harmony import */ var _SearchResults__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(355);


/***/ }),

/***/ 359:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(132);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(135);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_flat_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(253);
/* harmony import */ var core_js_modules_es_array_flat_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_flat_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(142);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(146);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(195);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(229);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(171);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(148);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(147);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(123);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(124);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(137);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(138);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(139);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(326);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(333);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(243);
/* harmony import */ var _assets_svg_icon_cross_svg__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(347);
/* harmony import */ var _cart_item__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(360);
/* harmony import */ var _free_shipping_bar__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(364);
/* harmony import */ var _reorder_bar__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(366);


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




















function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }








var emptyCart = {
  item_count: 0,
  items: [],
  total_price: 0
};

var SideCart = function SideCart(_ref) {
  var rootUrl = _ref.rootUrl,
      freeShippingBarSettings = _ref.freeShippingBarSettings;
  var defaultCart = window.theme.cart ? window.theme.cart : emptyCart;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(defaultCart),
      _useState2 = _slicedToArray(_useState, 2),
      cart = _useState2[0],
      setCart = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_19__.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      reOrderItems = _useState6[0],
      setReOrderItems = _useState6[1];

  var itemsCount = cart.item_count;
  var cartItems = cart.items;
  var total = cart.total_price;

  var updateCart = function updateCart(newCart) {
    setCart(newCart);
    var counters = document.querySelectorAll('[data-items-count]');
    counters.forEach(function (counter) {
      counter.innerHTML = newCart.item_count;

      if (newCart.item_count === 0) {
        counter.classList.add('visually-hidden');
      } else {
        counter.classList.remove('visually-hidden');
      }
    });
  };

  var fetchCart = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var url, options, response, json;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = "".concat(rootUrl, "/cart.js");
              options = {
                headers: {
                  'Content-Type': 'application/json'
                }
              };
              _context.prev = 2;
              _context.next = 5;
              return fetch(url, options);

            case 5:
              response = _context.sent;

              if (!(response.ok === false)) {
                _context.next = 8;
                break;
              }

              throw new Error('Fetch cart response was not OK');

            case 8:
              _context.next = 10;
              return response.json();

            case 10:
              json = _context.sent;
              return _context.abrupt("return", json);

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](2);
              window.console.error(_context.t0);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 14]]);
    }));

    return function fetchCart() {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   *
   * @typedef {Object} Item
   * @property {number} id - The Shopify variant ID.
   * @property {number} quantity - The quantity to add of this variant.
   * @property {Object.<string, string>} [properties] - Optional line item properties.
   * @property {Object} [variant] - Optional variant.
   */

  /**
   *
   * @param {...Item} items - Array of {@link Item} objects to add to cart.
   */


  var addLineItems = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(items) {
      var data, url, options, response, errorResponse, cartContents;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              data = {
                items: [items].flat()
              };
              url = "".concat(rootUrl, "/cart/add.js");
              options = {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
              };
              _context2.prev = 3;
              _context2.next = 6;
              return fetch(url, options);

            case 6:
              response = _context2.sent;

              if (!(response.ok === false)) {
                _context2.next = 12;
                break;
              }

              _context2.next = 10;
              return response.json();

            case 10:
              errorResponse = _context2.sent;
              setErrorMessage(errorResponse.description);

            case 12:
              _context2.next = 14;
              return fetchCart();

            case 14:
              cartContents = _context2.sent;
              updateCart(cartContents);
              _context2.next = 21;
              break;

            case 18:
              _context2.prev = 18;
              _context2.t0 = _context2["catch"](3);
              window.console.error(_context2.t0);

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 18]]);
    }));

    return function addLineItems(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var updateLineItems = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(updates) {
      var data, url, options, response, cartContents, _cartContents;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              data = {
                updates: updates
              };
              url = "".concat(rootUrl, "/cart/update.js");
              options = {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
              };
              _context3.prev = 3;
              _context3.next = 6;
              return fetch(url, options);

            case 6:
              response = _context3.sent;

              if (!(response.ok === false)) {
                _context3.next = 9;
                break;
              }

              throw new Error('cart/update response was not OK');

            case 9:
              _context3.next = 11;
              return response.json();

            case 11:
              cartContents = _context3.sent;
              updateCart(cartContents);
              _context3.next = 18;
              break;

            case 15:
              _context3.prev = 15;
              _context3.t0 = _context3["catch"](3);
              window.console.error(_context3.t0);

            case 18:
              _context3.prev = 18;
              _context3.next = 21;
              return fetchCart();

            case 21:
              _cartContents = _context3.sent;
              updateCart(_cartContents);
              return _context3.finish(18);

            case 24:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 15, 18, 24]]);
    }));

    return function updateLineItems(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleCartToggle = function handleCartToggle(event) {
    if (event) {
      event.preventDefault();
    }

    if (document.body.classList.contains('cart-is-visible')) {
      document.body.classList.remove('cart-is-visible');
      var cartOpenButton = document.querySelector('.header__btn--cart');

      if (cartOpenButton) {
        cartOpenButton.focus();
      }
    } else {
      document.body.classList.add('cart-is-visible');
      var cartCloseButton = document.querySelector('.side-cart__close');

      if (cartCloseButton) {
        cartCloseButton.focus();
      }
    }
  };
  /**
   *
   * @param {...Item} items - Array of {@link Item} objects to add to cart.
   * @param {boolean} openCart - Triggers the cart to open when item added if true
   */


  var handleAddToCartEvent = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(items) {
      var openCart,
          lineItems,
          _args4 = arguments;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              openCart = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : false;
              // Items could contain extra data like properties or variant info.
              // This reassignment strips out all but id, qty and properties to pass
              // to the addLineItems function for the cart.
              lineItems = [items].flat().map(function (item) {
                // ID and Qty will always be part of the array
                var newLineItem = {
                  id: item.id,
                  quantity: item.quantity
                }; // Only add properties if they exist

                if ('properties' in item) {
                  newLineItem.properties = item.properties;
                }

                return newLineItem;
              });
              _context4.prev = 2;
              _context4.next = 5;
              return addLineItems(lineItems);

            case 5:
              if (openCart) {
                handleCartToggle();
              }

              _context4.next = 11;
              break;

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](2);
              window.console.error(_context4.t0);

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[2, 8]]);
    }));

    return function handleAddToCartEvent(_x3) {
      return _ref5.apply(this, arguments);
    };
  }(); // Get & return reorder data from our liquid template


  var fetchReOrderData = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var url, options, response, data;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              url = "".concat(rootUrl, "/cart?view=order-data");
              options = {
                headers: {
                  'Content-Type': 'application/json'
                }
              };
              _context5.prev = 2;
              _context5.next = 5;
              return fetch(url, options);

            case 5:
              response = _context5.sent;

              if (!(response.ok === false)) {
                _context5.next = 8;
                break;
              }

              throw new Error('Fetch cart response was not OK');

            case 8:
              _context5.next = 10;
              return response.json();

            case 10:
              data = _context5.sent;
              return _context5.abrupt("return", data);

            case 14:
              _context5.prev = 14;
              _context5.t0 = _context5["catch"](2);
              window.console.error(_context5.t0);

            case 17:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[2, 14]]);
    }));

    return function fetchReOrderData() {
      return _ref6.apply(this, arguments);
    };
  }();

  var totalsElement = (0,react__WEBPACK_IMPORTED_MODULE_19__.useRef)(null); // Get the height of the sticky 'totals' element so the reorder element can be offset from it. If it doesnt exist for some reason, just stick the reorder bar to the bottom of the cart items list

  var setReOrderBarPosition = function setReOrderBarPosition() {
    var reorderPositionValue = totalsElement.current ? "".concat(totalsElement.current.clientHeight - 1, "px") : 0;
    document.documentElement.style.setProperty('--side-cart-reorder-position', reorderPositionValue);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_19__.useEffect)(function () {
    var transformReOrderData = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var reOrderItemData, uniqueLineItems, _reOrderItemData$orde;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return fetchReOrderData();

              case 2:
                reOrderItemData = _context6.sent;
                uniqueLineItems = [];

                if (reOrderItemData.order_count === 0) {
                  setReOrderItems([]);
                } else {
                  (_reOrderItemData$orde = reOrderItemData.orders) === null || _reOrderItemData$orde === void 0 ? void 0 : _reOrderItemData$orde.forEach(function (order) {
                    var availableItems = order.line_items.filter(function (item) {
                      return item.available;
                    });
                    availableItems.forEach(function (lineItem) {
                      lineItem.order_date = order.created_at;

                      if (uniqueLineItems.indexOf(lineItem) === -1) {
                        uniqueLineItems.push(lineItem);
                      }
                    });
                  });
                  setReOrderItems(uniqueLineItems);
                }

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function transformReOrderData() {
        return _ref7.apply(this, arguments);
      };
    }();

    transformReOrderData();
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_19__.useEffect)(function () {
    window.sideCart = {
      handleAddToCartEvent: handleAddToCartEvent
    };
    var cartToggles = document.querySelectorAll('[data-toggle-cart]');
    cartToggles.forEach(function (cartToggle) {
      return cartToggle.addEventListener('click', handleCartToggle);
    });
    setReOrderBarPosition();
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_19__.useEffect)(function () {
    var fetchInitialCart = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var cartContents;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return fetchCart();

              case 2:
                cartContents = _context7.sent;
                updateCart(cartContents);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function fetchInitialCart() {
        return _ref8.apply(this, arguments);
      };
    }();

    fetchInitialCart();
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_19__.useEffect)(function () {
    window.onpageshow = function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    };
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_19__.default.createElement(react__WEBPACK_IMPORTED_MODULE_19__.default.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_19__.default.createElement("div", {
    className: "side-cart__header"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_19__.default.createElement("h5", {
    className: "h-secondary side-cart__title"
  }, window.theme.strings.cartTitle, itemsCount > 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_19__.default.createElement(react__WEBPACK_IMPORTED_MODULE_19__.default.Fragment, null, ": ", itemsCount)), freeShippingBarSettings.enabled && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_19__.default.createElement(_free_shipping_bar__WEBPACK_IMPORTED_MODULE_24__.default, {
    total: total,
    freeShippingBarSettings: freeShippingBarSettings
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_19__.default.createElement("button", {
    type: "button",
    className: "side-cart__close",
    "aria-label": window.theme.strings.closeCart,
    "data-toggle-cart": true
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_19__.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: _assets_svg_icon_cross_svg__WEBPACK_IMPORTED_MODULE_22__
    }
  }))), errorMessage && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_19__.default.createElement("div", {
    className: "side-cart__error-message"
  }, errorMessage, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_19__.default.createElement("button", {
    type: "button",
    className: "side-cart__dismiss-message",
    "aria-label": window.theme.strings.dismissErrorMessage,
    onClick: function onClick() {
      return setErrorMessage(null);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_19__.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: _assets_svg_icon_cross_svg__WEBPACK_IMPORTED_MODULE_22__
    }
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_19__.default.createElement("div", {
    className: "side-cart__content-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_19__.default.createElement("div", {
    className: "side-cart__content"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_19__.default.createElement("ul", {
    className: "side-cart__cart-items-container list-none"
  }, cartItems.length ? cartItems.map(function (item) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_19__.default.createElement(_cart_item__WEBPACK_IMPORTED_MODULE_23__.default, {
      item: item,
      updateLineItems: updateLineItems,
      key: item.key
    });
  }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_19__.default.createElement("li", {
    className: "side-cart__empty"
  }, window.theme.strings.cartEmpty))), reOrderItems && reOrderItems.length ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_19__.default.createElement(_reorder_bar__WEBPACK_IMPORTED_MODULE_25__.default, {
    reOrderItems: reOrderItems,
    cart: cart,
    handleAddToCartEvent: handleAddToCartEvent
  }) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_19__.default.createElement("div", {
    className: "side-cart__totals",
    ref: totalsElement
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_19__.default.createElement("div", {
    className: "side-cart__subtotals"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_19__.default.createElement("div", {
    className: "side-cart__subtotal"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_19__.default.createElement("span", null, window.theme.strings.subtotal), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_19__.default.createElement(react__WEBPACK_IMPORTED_MODULE_19__.default.Fragment, null, (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_21__.formatMoney)(total, window.theme.moneyFormat), " ", window.theme.cart.currency))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_19__.default.createElement("div", {
    className: "side-cart__checkout"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_19__.default.createElement("a", {
    href: "".concat(rootUrl, "/checkout"),
    className: "btn btn--primary"
  }, window.theme.strings.checkout)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_19__.default.createElement("button", {
    type: "button",
    "class": "side-cart__continue-shopping btn btn--text",
    "aria-label": window.theme.strings.closeCart,
    "data-toggle-cart": true
  }, window.theme.strings.continueShopping))));
};

SideCart.propTypes = {
  rootUrl: (prop_types__WEBPACK_IMPORTED_MODULE_20___default().string),
  freeShippingBarSettings: (prop_types__WEBPACK_IMPORTED_MODULE_20___default().func)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SideCart);

/***/ }),

/***/ 361:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(179);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(350);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(326);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(333);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(243);
/* harmony import */ var _assets_scripts_utils_shopify_images__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(357);
/* harmony import */ var _assets_svg_icon_minus_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(362);
/* harmony import */ var _assets_svg_icon_plus_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(363);



function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var CartItem = function CartItem(_ref) {
  var _item$featured_image, _item$featured_image2;

  var item = _ref.item,
      updateLineItems = _ref.updateLineItems;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("li", {
    className: "cart-item"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("div", {
    className: "cart-item__content-wrapper"
  }, (item === null || item === void 0 ? void 0 : (_item$featured_image = item.featured_image) === null || _item$featured_image === void 0 ? void 0 : _item$featured_image.url) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("div", {
    className: "cart-item__image"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("a", {
    href: item.url
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("img", {
    src: (0,_assets_scripts_utils_shopify_images__WEBPACK_IMPORTED_MODULE_5__.imageUrl)(item.featured_image.url, 160),
    width: 160,
    alt: item.title,
    loading: "lazy"
  }))), !(item !== null && item !== void 0 && (_item$featured_image2 = item.featured_image) !== null && _item$featured_image2 !== void 0 && _item$featured_image2.url) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("div", {
    className: "cart-item__image"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("a", {
    href: item.url
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("svg", {
    "class": "component-image__image placeholder-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 525.5 525.5"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("path", {
    d: "M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("path", {
    d: "M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("path", {
    d: "M232.8 254c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3zm0-14.9c3.6 0 6.6 2.9 6.6 6.6s-2.9 6.6-6.6 6.6-6.6-2.9-6.6-6.6 3-6.6 6.6-6.6z"
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("div", {
    className: "cart-item__content"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("div", {
    className: "cart-item__content-group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("p", {
    className: "cart-item__title"
  }, item.product_title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("p", {
    className: "cart-item__description"
  }, item.variant_title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("p", {
    className: "cart-item__price"
  }, (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__.formatMoney)(item.line_price, window.theme.moneyFormat))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("div", {
    "class": "cart-item__quantity-remove-wrapper"
  }, item.line_price > 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("div", {
    className: "quantity-selector"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("button", {
    onClick: function onClick() {
      return updateLineItems(_defineProperty({}, item.key, item.quantity - 1));
    },
    className: "btn--icon",
    type: "button"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: _assets_svg_icon_minus_svg__WEBPACK_IMPORTED_MODULE_6__
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("input", {
    id: "cart-qty_".concat(item.key),
    type: "number",
    name: "quantity",
    min: "1",
    "aria-label": window.theme.strings.itemQuantity,
    value: item.quantity,
    autoComplete: "off",
    onBlur: function onBlur(event) {
      return item.quantity === Number(event.target.value) ? null : updateLineItems(_defineProperty({}, item.key, event.target.value));
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("button", {
    onClick: function onClick() {
      return updateLineItems(_defineProperty({}, item.key, item.quantity + 1));
    },
    className: "btn--icon",
    type: "button"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: _assets_svg_icon_plus_svg__WEBPACK_IMPORTED_MODULE_7__
    }
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("button", {
    className: "cart-item__remove btn btn--text",
    onClick: function onClick() {
      return updateLineItems(_defineProperty({}, item.key, 0));
    },
    type: "button"
  }, "Remove")))));
};

CartItem.propTypes = {
  item: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object),
  updateLineItems: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CartItem);

/***/ }),

/***/ 360:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* reexport safe */ _CartItem__WEBPACK_IMPORTED_MODULE_0__.default)
/* harmony export */ });
/* harmony import */ var _CartItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(361);


/***/ }),

/***/ 365:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(102);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(110);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(326);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(333);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(243);






var FreeShippingBar = function FreeShippingBar(_ref) {
  var total = _ref.total,
      freeShippingBarSettings = _ref.freeShippingBarSettings;
  var remainingTemplate = freeShippingBarSettings.remainingTemplate,
      reachedTemplate = freeShippingBarSettings.reachedTemplate,
      serviceOne = freeShippingBarSettings.serviceOne,
      serviceTwo = freeShippingBarSettings.serviceTwo,
      thresholdOne = freeShippingBarSettings.thresholdOne,
      thresholdTwo = freeShippingBarSettings.thresholdTwo;
  /**
   * Create the free shipping remaining spend message.
   * @param {number} cartTotal
   * @param {number} threshold
   * @param {string} service
   * @returns {string}
   */

  var createRemainingMessage = function createRemainingMessage(cartTotal, threshold, service) {
    var remainingAmt = (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__.formatMoney)(threshold - cartTotal, window.theme.moneyFormat);
    return remainingTemplate.replace('{{ amount }}', remainingAmt).replace('{{ service }}', service);
  };
  /**
   * Construct free shipping bar percentage and message.
   *
   * @return {{percentage:Number, message:String}}
   */


  var calcFreeShippingStatus = function calcFreeShippingStatus() {
    if (total < thresholdOne) {
      return {
        barPercentage: total / thresholdOne * 100,
        barMessage: createRemainingMessage(total, thresholdOne, serviceOne)
      };
    } else if (thresholdTwo && total < thresholdTwo) {
      return {
        barPercentage: total / thresholdTwo * 100,
        barMessage: createRemainingMessage(total, thresholdTwo, serviceTwo)
      };
    } else {
      var service = thresholdTwo ? serviceTwo : serviceOne;
      return {
        barPercentage: 100,
        barMessage: reachedTemplate.replace('{{ service }}', service)
      };
    }
  };

  var _calcFreeShippingStat = calcFreeShippingStatus(),
      barPercentage = _calcFreeShippingStat.barPercentage,
      barMessage = _calcFreeShippingStat.barMessage;

  var barWidth = {
    width: "".concat(barPercentage, "%")
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("div", {
    className: "side-cart__free-shipping"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("div", {
    className: "side-cart__progress"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("div", {
    className: "side-cart__progress-bar",
    style: barWidth
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.default.createElement("p", null, barMessage));
};

FreeShippingBar.propTypes = {
  total: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
  freeShippingBarSettings: prop_types__WEBPACK_IMPORTED_MODULE_3___default().shape({
    enabled: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool.isRequired),
    remainingTemplate: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
    reachedTemplate: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
    serviceOne: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
    serviceTwo: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    thresholdOne: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number.isRequired),
    thresholdTwo: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number)
  })
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FreeShippingBar);

/***/ }),

/***/ 364:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* reexport safe */ _FreeShippingBar__WEBPACK_IMPORTED_MODULE_0__.default)
/* harmony export */ });
/* harmony import */ var _FreeShippingBar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(365);


/***/ }),

/***/ 358:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* reexport safe */ _SideCart__WEBPACK_IMPORTED_MODULE_0__.default)
/* harmony export */ });
/* harmony import */ var _SideCart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(359);


/***/ }),

/***/ 367:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(229);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(252);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(137);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(195);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(102);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(110);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(326);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(333);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_flickity_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(368);
/* harmony import */ var react_flickity_component__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react_flickity_component__WEBPACK_IMPORTED_MODULE_8__);









var flickityOptions = {
  prevNextButtons: false,
  cellAlign: 'left',
  groupCells: 2
};

var ReOrderBar = function ReOrderBar(_ref) {
  var reOrderItems = _ref.reOrderItems,
      cart = _ref.cart;

  var filteredReOrderData = function filteredReOrderData() {
    var onlyItemsNotInCart = reOrderItems.filter(function (item) {
      return !cart.items.find(function (cartItem) {
        return cartItem.variant_id === item.variant_id;
      });
    });
    var firstEightItems = onlyItemsNotInCart.slice(0, 8);
    return firstEightItems;
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.default.createElement(react__WEBPACK_IMPORTED_MODULE_6__.default.Fragment, null, filteredReOrderData() && filteredReOrderData().length && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.default.createElement("div", {
    className: "side-cart-reorder"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.default.createElement("div", {
    className: "side-cart-reorder__title h6 h-small"
  }, window.theme.strings.orderAgain), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.default.createElement((react_flickity_component__WEBPACK_IMPORTED_MODULE_8___default()), {
    options: flickityOptions
  }, filteredReOrderData().map(function (item) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.default.createElement("div", {
      className: "reorder-slide",
      key: item.index
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.default.createElement("div", {
      className: "reorder-item",
      key: item.id
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.default.createElement("div", {
      className: "reorder-item__title"
    }, item.title.replace('&amp;', '&')), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.default.createElement("div", {
      className: "reorder-item__detail-wrapper"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.default.createElement(react__WEBPACK_IMPORTED_MODULE_6__.default.Fragment, null, item.original_price, " - ", item.order_date), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.default.createElement("button", {
      type: "button",
      onClick: function onClick() {
        var _window$sideCart;

        return (_window$sideCart = window.sideCart) === null || _window$sideCart === void 0 ? void 0 : _window$sideCart.handleAddToCartEvent({
          id: item.variant_id,
          quantity: 1
        }, false);
      }
    }, window.theme.strings.reOrder))));
  }))));
};

ReOrderBar.propTypes = {
  reOrderItems: prop_types__WEBPACK_IMPORTED_MODULE_7___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_7___default().object)),
  cart: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().object)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ReOrderBar);

/***/ }),

/***/ 366:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* reexport safe */ _ReOrderBar__WEBPACK_IMPORTED_MODULE_0__.default)
/* harmony export */ });
/* harmony import */ var _ReOrderBar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(367);


/***/ }),

/***/ 325:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(179);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(102);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(205);
/* harmony import */ var core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(326);
/* harmony import */ var _assets_svg_icon_search_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(328);
/* harmony import */ var _assets_svg_icon_close_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(329);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(330);










var App = function App() {
  if (window.theme.ecommerce) {
    var rootUrl = window.theme.locale && !window.theme.locale.primary ? window.theme.locale.rootUrl : '';
    var freeShippingBarSettings = {
      enabled: window.theme.freeShippingBar && window.theme.freeShippingBar.enabled,
      remainingTemplate: window.theme.strings.freeShippingBar.remaining,
      reachedTemplate: window.theme.strings.freeShippingBar.reached,
      serviceOne: window.theme.freeShippingBar.serviceOne,
      serviceTwo: window.theme.freeShippingBar && window.theme.freeShippingBar.serviceTwo ? window.theme.freeShippingBar.serviceTwo : null,
      thresholdOne: Number(window.theme.freeShippingBar.thresholdOne) * 100,
      thresholdTwo: window.theme.freeShippingBar && window.theme.freeShippingBar.thresholdTwo ? Number(window.theme.freeShippingBar.thresholdTwo) * 100 : null
    };
    react__WEBPACK_IMPORTED_MODULE_4__.default.render( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.default.createElement(_components__WEBPACK_IMPORTED_MODULE_7__.SideCart, {
      rootUrl: rootUrl,
      freeShippingBarSettings: freeShippingBarSettings
    }), document.querySelector('#react-side-cart'));
  }

  var mobileQuery = window.matchMedia("(max-width: ".concat(window.theme.breakpoints.large, "px)"));
  var headerSearchEl = mobileQuery.matches ? document.querySelector('#react-search-modal--mobile') : document.querySelector('#react-search-modal');

  if (headerSearchEl && window.theme.searchSettings.enableInstantSearch) {
    react__WEBPACK_IMPORTED_MODULE_4__.default.render( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.default.createElement(react__WEBPACK_IMPORTED_MODULE_4__.default.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.default.createElement(_components__WEBPACK_IMPORTED_MODULE_7__.Search, {
      triggerLabel: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.default.createElement(react__WEBPACK_IMPORTED_MODULE_4__.default.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.default.createElement("span", {
        className: "h-small h6",
        style: "width:100%;"
      }, window.theme.strings.search.search)),
      placeholder: window.theme.strings.search.placeholder,
      rootUrl: window.theme.locale && window.theme.locale.primary ? '' : window.theme.locale.rootUrl,
      resources: {
        type: window.theme.searchSettings.types.join(','),
        limit: window.theme.searchSettings.limit
      },
      unavailableProducts: window.theme.searchSettings.unavailable_products,
      enableInstantSearch: window.theme.searchSettings.enableInstantSearch,
      showSearchSuggestions: window.theme.searchSettings.showSearchSuggestions,
      searchSuggestionsTitle: window.theme.strings.search.topSearches,
      searchSuggestions: window.theme.searchSettings.searchSuggestions,
      resultMoneyFormat: window.theme.moneyFormat,
      searchIcon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.default.createElement(react__WEBPACK_IMPORTED_MODULE_4__.default.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.default.createElement("span", {
        className: "search-icon",
        dangerouslySetInnerHTML: {
          __html: _assets_svg_icon_search_svg__WEBPACK_IMPORTED_MODULE_5__
        }
      })),
      clearIcon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.default.createElement(react__WEBPACK_IMPORTED_MODULE_4__.default.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: _assets_svg_icon_close_svg__WEBPACK_IMPORTED_MODULE_6__
        }
      })),
      typeProductsTitle: window.theme.strings.search.typeProducts,
      typeCollectionsTitle: window.theme.strings.search.typeCollections,
      typeArticlesTitle: window.theme.strings.search.typeArticles,
      typePagesTitle: window.theme.strings.search.typePages,
      viewAllString: window.theme.strings.search.viewAllProducts
    })), headerSearchEl);
  }

  var searchPageEl = document.querySelector('#react-search-results');

  if (searchPageEl && window.theme.searchSettings.enableInstantSearch) {
    react__WEBPACK_IMPORTED_MODULE_4__.default.render( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.default.createElement(_components__WEBPACK_IMPORTED_MODULE_7__.Search, {
      placeholder: window.theme.strings.search.placeholder,
      rootUrl: window.theme.locale && window.theme.locale.primary ? '' : window.theme.locale.rootUrl,
      resources: {
        type: window.theme.searchSettings.types.join(','),
        limit: window.theme.searchSettings.limit
      },
      unavailableProducts: window.theme.searchSettings.unavailable_products,
      enableInstantSearch: window.theme.searchSettings.enableInstantSearch,
      showSearchSuggestions: window.theme.searchSettings.showSearchSuggestions,
      searchSuggestionsTitle: window.theme.strings.search.topSearches,
      searchSuggestions: window.theme.searchSettings.searchSuggestions,
      resultMoneyFormat: window.theme.moneyFormat,
      searchIcon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.default.createElement(react__WEBPACK_IMPORTED_MODULE_4__.default.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.default.createElement("span", {
        className: "search-icon",
        dangerouslySetInnerHTML: {
          __html: _assets_svg_icon_search_svg__WEBPACK_IMPORTED_MODULE_5__
        }
      })),
      clearIcon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.default.createElement(react__WEBPACK_IMPORTED_MODULE_4__.default.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: _assets_svg_icon_close_svg__WEBPACK_IMPORTED_MODULE_6__
        }
      })),
      helpText: window.theme.strings.search.helpText,
      typeProductsTitle: window.theme.strings.search.typeProducts,
      typeCollectionsTitle: window.theme.strings.search.typeCollections,
      typeArticlesTitle: window.theme.strings.search.typeArticles,
      typePagesTitle: window.theme.strings.search.typePages,
      viewAllString: window.theme.strings.search.viewAll
    }), searchPageEl);
  }
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (App);

/***/ }),

/***/ 272:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "apiEndpoint": () => (/* binding */ apiEndpoint),
/* harmony export */   "storefrontRequestConfig": () => (/* binding */ storefrontRequestConfig),
/* harmony export */   "xhrRequestConfig": () => (/* binding */ xhrRequestConfig)
/* harmony export */ });
// Details for Storefront API.
var storefrontAccessToken = {
  ifw: '4bc6c32d309733663e1b4eb619f15b7e',
  bib: '280882b68a5af50e8175ad86ba440d78'
};
var apiEndPoints = {
  bib: 'https://bibendum-wine-co.myshopify.com',
  ifw: 'https://ifw-production.myshopify.com'
};

function getApiEndPoint() {
  return Shopify.shop == 'bibendum-wine-co.myshopify.com' ? apiEndPoints.dev : apiEndPoints.prod;
}

var apiEndpoint = getApiEndPoint();

function getAccessToken() {
  return Shopify.shop == 'bibendum-wine-co.myshopify.com' ? storefrontAccessToken.bib : storefrontAccessToken.ifw;
}

var storefrontRequestConfig = {
  headers: {
    'Content-Type': 'application/graphql',
    'X-Shopify-Storefront-Access-Token': getAccessToken()
  }
}; // XHR request header is required to catch certain errors e.g. adding over quantity available
// https://community.shopify.com/c/Shopify-Design/AJAX-POST-cart-add-js-NEVER-returns-422-only-200-OK-on/m-p/375736
// https://stackoverflow.com/questions/17478731/whats-the-point-of-the-x-requested-with-header

var xhrRequestConfig = {
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
};

/***/ }),

/***/ 196:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "debounce": () => (/* binding */ debounce)
/* harmony export */ });
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(177);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0__);

var debounce = function debounce(callback) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
  var timeoutId;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timeoutId);
    timeoutId = setTimeout(function () {
      timeoutId = null;
      callback.apply(void 0, args);
    }, delay);
  };
};

/***/ }),

/***/ 251:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "discountedProductPrice": () => (/* binding */ discountedProductPrice)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(230);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(231);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(252);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(102);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(110);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(179);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_flat_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(253);
/* harmony import */ var core_js_modules_es_array_flat_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_flat_js__WEBPACK_IMPORTED_MODULE_6__);








/**
 * This function returns a product price based on the same tag based logic used
 * in Shopify scripts.
 */
var CG_LUC = 'CUSTOMER_GROUP:LUC';
var CG_STAFF = 'CUSTOMER_GROUP:STAFF';
var CG_WETDWS = 'CUSTOMER_GROUP:WETDWS';
var DG_DOMESTIC = 'DISCOUNT_GROUP:DOMESTIC';
var DG_IMPORT = 'DISCOUNT_GROUP:IMPORT';
var DG_ACCESSORIES = 'DISCOUNT_GROUP:ACCESSORIES';
var DG_SPIRITS = 'DISCOUNT_GROUP:SPIRITS';
var DG_MIXERS = 'DISCOUNT_GROUP:MIXERS';
var DG_EXEMPT = 'DISCOUNT_GROUP:EXEMPT';
var discountedProductPrice = function discountedProductPrice(customerTags, productPrice, productTags, productSku) {
  var _ref, _productTags$find;

  if (!customerTags || customerTags.length === 0 || !productTags || productTags.length === 0 || productTags.includes(DG_EXEMPT)) {
    return productPrice;
  }

  var customerGroupTag = customerTags.find(function (tag) {
    return tag === CG_LUC || tag === CG_STAFF || tag === CG_WETDWS;
  });

  if (!customerGroupTag) {
    return productPrice;
  }

  var customerGroup = customerGroupTag.replace('CUSTOMER_GROUP:', '');

  if (!customerGroup) {
    return productPrice;
  }

  var productGroup = "PRICE:".concat(customerGroup, ":");
  var customerGroupItemPrice = Number((_ref = ((_productTags$find = productTags.find(function (tag) {
    return tag.includes(productGroup);
  })) === null || _productTags$find === void 0 ? void 0 : _productTags$find.replace(productGroup, '')) * 100) !== null && _ref !== void 0 ? _ref : 0);

  if (!customerGroupItemPrice) {
    return productPrice;
  }

  var sku = [productSku].flat()[0];
  var discountGroupTag = productTags.find(function (tag) {
    return tag === DG_DOMESTIC || tag === DG_IMPORT || tag === DG_ACCESSORIES || tag === DG_SPIRITS || tag === DG_MIXERS;
  });
  var customerDiscountGroupPrefix = "".concat(discountGroupTag, ":");
  var customerSkuHvwcPrefix = "HVWC:".concat(sku, ":");
  var customerDiscountGroupTag = discountGroupTag && customerTags.find(function (tag) {
    return tag.includes(customerDiscountGroupPrefix);
  });
  var customerSkuHvwcTag = sku && customerTags.find(function (tag) {
    return tag.includes(customerSkuHvwcPrefix);
  });
  var discounts = [];

  if (customerDiscountGroupTag) {
    var discountValue = Number(customerDiscountGroupTag.replace(customerDiscountGroupPrefix, ''));
    discounts.push(discountValue);
  }

  if (customerSkuHvwcTag) {
    var _discountValue = Number(customerSkuHvwcTag.replace(customerSkuHvwcPrefix, ''));

    discounts.push(_discountValue);
  }

  if (!discounts.length) {
    return customerGroupItemPrice;
  }

  var highestPercentageDiscount = Math.max.apply(Math, discounts);
  var discountedPrice = Math.round((100 - highestPercentageDiscount) / 100 * customerGroupItemPrice);
  return discountedPrice;
};

/***/ }),

/***/ 357:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "imageUrl": () => (/* binding */ imageUrl)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(123);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(124);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(184);
/* harmony import */ var core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_4__);






/**
 * Replicates Shopify's `image_url` filter in js.
 * - At least one of `width` or `height` must be provided.
 * - If no `crop` is provided, it will default to `center`.
 * - `format` and `pad_color` are unsupported.
 *
 * @param {string} url - Shopify image url.
 * @param {number} [width] - Image width integer (max 5760).
 * @param {number} [height] - Image height integer (max 5760).
 * @param {('top'|'bottom'|'center'|'left'|'right')} [crop="center"] - Image crop, defaults to `center`.
 * @returns {string}
 */
var imageUrl = function imageUrl(url, width, height, crop) {
  if (!url || !(width || height)) return null;
  if (width && typeof width !== 'number') return null;
  if (height && typeof height !== 'number') return null;
  if (crop && typeof crop !== 'string') return null;

  try {
    var urlObj = new URL(url);
    var params = urlObj.searchParams;
    var currentWidth = params.get('width');
    var currentHeight = params.get('height');
    var currentCrop = params.get('crop');
    if (!height && currentHeight) params["delete"]('height');
    if (!width && currentWidth) params["delete"]('width');
    if (!crop && currentCrop) params["delete"]('crop');
    if (width) params.set('width', width);
    if (height) params.set('height', height);
    if (crop) params.set('crop', crop);
    return urlObj.href;
  } catch (error) {
    return null;
  }
};

/***/ }),

/***/ 329:
/***/ ((module) => {

"use strict";
module.exports = "<svg width=\"18\" height=\"17\" viewBox=\"0 0 18 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<ellipse cx=\"9.40942\" cy=\"8.5\" rx=\"8.52368\" ry=\"8.5\" fill=\"#D9D9D9\"/>\n<path d=\"M12.0734 5.84375L6.74609 11.1563\" stroke=\"#4D4D4D\" stroke-linecap=\"square\"/>\n<path d=\"M6.74609 5.84375L12.0734 11.1563\" stroke=\"#4D4D4D\" stroke-linecap=\"square\"/>\n</svg>\n";

/***/ }),

/***/ 347:
/***/ ((module) => {

"use strict";
module.exports = "<svg aria-label=\"Cross icon\" class=\"icon icon-cross\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"1.5\" vector-effect=\"non-scaling-stroke\" d=\"M17 7L7 17M7 7l10 10\"/></svg>";

/***/ }),

/***/ 362:
/***/ ((module) => {

"use strict";
module.exports = "<svg aria-label=\"Minus icon\" class=\"icon icon-minus\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M4 12L20 12\" stroke=\"currentColor\" stroke-linecap=\"square\" vector-effect=\"non-scaling-stroke\"/>\n</svg>\n";

/***/ }),

/***/ 363:
/***/ ((module) => {

"use strict";
module.exports = "<svg aria-label=\"Plus icon\" class=\"icon icon-plus\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M12 4.24707V20.2471\" stroke=\"currentColor\" stroke-linecap=\"square\" vector-effect=\"non-scaling-stroke\"/>\n<path d=\"M4 12.2471H20\" stroke=\"currentColor\" stroke-linecap=\"square\" vector-effect=\"non-scaling-stroke\"/>\n</svg>\n";

/***/ }),

/***/ 328:
/***/ ((module) => {

"use strict";
module.exports = "<svg width=\"17\" height=\"17\" viewBox=\"0 0 17 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M10.9219 11.0449L15.7314 16.0949\" stroke=\"#4D4D4D\"/>\n<path d=\"M7.18172 12.4225C10.6163 12.4225 13.4005 9.7916 13.4005 6.54622C13.4005 3.30083 10.6163 0.669922 7.18172 0.669922C3.74715 0.669922 0.962891 3.30083 0.962891 6.54622C0.962891 9.7916 3.74715 12.4225 7.18172 12.4225Z\" stroke=\"#4D4D4D\"/>\n</svg>\n";

/***/ })

}]);